import { render, staticRenderFns } from "./CollaboratorCard.vue?vue&type=template&id=0e95f21d&scoped=true&"
import script from "./CollaboratorCard.vue?vue&type=script&lang=js&"
export * from "./CollaboratorCard.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorCard.vue?vue&type=style&index=0&id=0e95f21d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e95f21d",
  null
  
)

export default component.exports